import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SeoService } from '../../../services/seo.service';
import { UtilityService } from '../../../services/utility.service';
import { routes } from '../../../constants/routes';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { AboutUsComponent } from '../../../components/layout/workshop/about-us/about-us/about-us.component'
import { AboutAikoshComponent } from '../../../components/layout/workshop/about-us/about-aikosh/about-aikosh.component';
import { BannerComponent } from '../../../components/layout/workshop/banner/banner.component';
import { ParticipateComponent } from '../../../components/layout/workshop/participate/participate.component';
import { BenifitsComponent } from '../../../components/layout/workshop/benifits/benifits.component';
import { WorkshopCTAComponent } from '../../../components/layout/workshop/workshop-cta/workshop-cta.component';
import { SupportComponent } from '../../../components/layout/workshop/support/support.component';
import { FooterComponent } from '../../../components/layout/workshop/footer/footer.component';
//import { StatsComponent } from '../../../components/layout/workshop/stats/stats.component';
import { statsComponent } from '../../../components/layout/stats/stats.component';
import { GainComponent } from '../../../components/layout/workshop/gain/gain.component';
import { FacultyBenefitsComponent } from '../../../components/layout/workshop/faculty-benefits/faculty-benefits.component';
import { AiFutureComponent } from '../../../components/layout/workshop/ai-future/ai-future.component';
import { WorkshopFaqComponent } from '../../../components/layout/workshop/workshop-faq/workshop-faq.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, skip } from 'rxjs';
import { CachingService } from '../../../services/caching.service';
@Component({
  selector: 'app-workshop-home',
  standalone: true,
  imports: [AboutUsComponent, AboutAikoshComponent,WorkshopFaqComponent, BannerComponent, ParticipateComponent, BenifitsComponent, WorkshopCTAComponent, SupportComponent, FooterComponent, statsComponent, GainComponent,FacultyBenefitsComponent,AiFutureComponent],
  templateUrl: './workshop-home.component.html',
  styleUrl: './workshop-home.component.scss'
})
export class WorkshopHomeComponent implements OnInit {
  isSubOptionOpen = false;
  renderUniversityContent = true;
  private readonly destroyRef = inject(DestroyRef);

  readonly routes = routes;
  constructor(
    private seoService: SeoService,
    protected utilityService: UtilityService,
    private cachingService: CachingService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    const { title, description, canonicalUrl } = pageSeoInfo['home'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
    this.subscribeToLanguageChange();
  }
  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshAppContent();
      });
  }
  private refreshAppContent(): void {
    this.renderUniversityContent = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.renderUniversityContent = true;
      this.cdr.detectChanges();
    });
  }
}
